import { createNewOrg, getAllOrgs, updateOrg } from '../api/orgs';

const ADD_ALL_ORGS = 'ADD_ALL_ORGS';
const ADD_NEW_ORG = 'ADD_NEW_ORG';
const LOADED_ALL_ORGS = 'LOADED_ALL_ORGS';
const UPDATE_EXISTING_ORG = 'UPDATE_EXISTING_ORG';

const INITIAL_STATE = {
  isAllOrgsLoaded: false,
  orgs: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_ALL_ORGS:
      return {
        ...state,
        orgs: [...action.payload].sort((a, b) => a.displayName.localeCompare(b.displayName)),
      };
    case ADD_NEW_ORG:
      return {
        orgs: [
          ...state.orgs,
          action.payload,
        ].sort((a, b) => a.displayName.localeCompare(b.displayName)),
      };
    case UPDATE_EXISTING_ORG:
      return {
        ...state,
        orgs: [
          ...state.orgs.filter(org => org.id !== action.payload.id),
          action.payload,
        ].sort((a, b) => a.displayName.localeCompare(b.displayName)),
      };
    case LOADED_ALL_ORGS:
      return {
        ...state,
        isAllOrgsLoaded: true,
      };
    default:
      return state;
  }
}

export function fetchAllOrgs() {
  return async (dispatch) => {
    try {
      const orgs = await getAllOrgs();

      dispatch({
        type: ADD_ALL_ORGS,
        payload: orgs,
      });

      return dispatch({ type: LOADED_ALL_ORGS });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function addNewOrg(org) {
  return async (dispatch) => {
    try {
      const o = await createNewOrg(org);

      return dispatch({
        type: ADD_NEW_ORG,
        payload: o,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function editExistingOrg(id, org) {
  return async (dispatch) => {
    try {
      const o = await updateOrg(id, org);

      return dispatch({
        type: UPDATE_EXISTING_ORG,
        payload: o,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
